import { useEffect } from 'react';

import { useStripe } from '@stripe/react-stripe-js';
import {
  getPharmacyBilling,
  PaymentPlans,
  resetBilling,
  StripePaymentStatus,
} from '@pharmaplan/common';

import {
  showError,
  showSuccess,
} from '../../components/Admin/Profile/Pharmacist/PharmacistViewProfile/helper';
import { planTypeQuery } from '../../helpers/Constants';
import { useAppDispatch } from '../useAppDispatch';
import strings from '../../localization';

const { basic, unlimited } = PaymentPlans;

const usePaymentRedirectSuccess = () => {
  const dispatch = useAppDispatch();
  const stripe = useStripe();
  const urlParams = new URLSearchParams(window.location.search);
  const planType = urlParams.get(planTypeQuery);

  const config = {
    [basic]: {
      secretRoute: 'setup_intent_client_secret',
      retrieveFunc: stripe?.retrieveSetupIntent,
      resName: 'setupIntent',
    },
    [unlimited]: {
      secretRoute: 'payment_intent_client_secret',
      retrieveFunc: stripe?.retrievePaymentIntent,
      resName: 'paymentIntent',
    },
  };

  const { secretRoute, retrieveFunc, resName } = config[planType as PaymentPlans] ?? {};
  const intentSecret = urlParams.get(secretRoute);

  useEffect(() => {
    if (!stripe) return;

    if (intentSecret) {
      retrieveFunc?.(intentSecret ?? '').then((res) => {
        const intent = res[resName as keyof typeof res] ?? {};
        switch (intent['status' as keyof typeof intent]) {
          case StripePaymentStatus.succeeded:
            showSuccess(dispatch, strings.savedSuccessfully);
            dispatch(getPharmacyBilling());
            break;

          case StripePaymentStatus.processing:
            showError(dispatch, strings.paymentInProgress);
            break;

          case StripePaymentStatus.requirePaymentMethod:
          case StripePaymentStatus.canceled:
            showError(dispatch, res?.error?.message ?? '');
            dispatch(resetBilling());
            break;
          default:
            break;
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intentSecret, stripe]);
};

export default usePaymentRedirectSuccess;
